export function NotFound() {
  return (
    <section>
      <h2>Not here</h2>
      <p>That page does not exist. Try the standings or the schedule.</p>
    </section>
  )
}
